import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drag",
  "use": "icon-drag-usage",
  "viewBox": "0 0 5 14",
  "content": "<symbol viewBox=\"0 0 5 14\" id=\"icon-drag\"><path d=\"M1 7.8c-.5 0-1 .5-1 1s.5 1 1 1 1-.4 1-1-.5-1-1-1m0 3.6a1 1 0 0 0-1 1 1 1 0 0 0 2 0c0-.6-.5-1-1-1m3-3.6c-.5 0-1 .5-1 1s.5 1 1 1 1-.4 1-1-.5-1-1-1m0 3.6a1 1 0 0 0-1 1 1 1 0 0 0 2 0c0-.6-.5-1-1-1M1 .6a1 1 0 0 0-1 1 1 1 0 0 0 2 0c0-.6-.5-1-1-1m0 3.6c-.5 0-1 .5-1 1s.5 1 1 1 1-.5 1-1-.5-1-1-1M4 .6a1 1 0 0 0-1 1 1 1 0 0 0 2 0c0-.6-.5-1-1-1m0 3.6c-.5 0-1 .5-1 1s.5 1 1 1 1-.5 1-1-.5-1-1-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol